export default class IdsAndConstants {
  static readonly details_item_item = "details.item.item";
  static readonly lines_account = "lines.account";
  static readonly fractionDecimalPlaces = "fractionDecimalPlaces";
  static readonly displayDecimalPlaces = "displayDecimalPlaces";
  static readonly data_originId = "data.originId";
  static readonly trnsData_originId = "trnsData.originId";
  static readonly cc1 = "cc1";
  static readonly cc2 = "cc2";
  static readonly cc3 = "cc3";
  static readonly ccEmail1 = "ccEmail1";
  static readonly ccEmail2 = "ccEmail2";
  static readonly ccEmail3 = "ccEmail3";
  static readonly content = "content";
  static readonly outputFormat = "outputFormat";
  static readonly subject = "subject";
  static readonly temPrintId = "temPrintId";
  static readonly to1 = "to1";
  static readonly to2 = "to2";
  static readonly to3 = "to3";
  static readonly toEmail1 = "toEmail1";
  static readonly toEmail2 = "toEmail2";
  static readonly toEmail3 = "toEmail3";
  static readonly attachment1 = "attachment1";
  static readonly AUTestDef = "AUTestDef";
  static readonly AUPhase = "AUPhase";
  static readonly details_specificDimensions_serialNumber = "details.specificDimensions.serialNumber";
  static readonly details_specificDimensions_secondSerial = "details.specificDimensions.secondSerial";
  static readonly MRN_REFRESH_CELLS = -999;
  static readonly SHOW_TIMELINE = "show-timeline";
  static readonly OTHER_DECISION = "otherDecision";
  static readonly ACTIONS_COLUMN = "AGActions";
  static readonly MEMBER_ADDED = "member_added";
  static readonly MEMBER_REMOVED = "member_removed";
  static readonly SET_NEW_PASSWORD_ACTION = "setNewPassword";
  static readonly NM_JSON_PREFIX = "@nm-json:";
}
